import { render, staticRenderFns } from "./AssessmentPageNew.vue?vue&type=template&id=278d07ae&scoped=true&"
import script from "./AssessmentPageNew.vue?vue&type=script&lang=js&"
export * from "./AssessmentPageNew.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentPageNew.vue?vue&type=style&index=0&id=278d07ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d07ae",
  null
  
)

export default component.exports